import React from "react";
import { Input } from "@windmill/react-ui";

const InputArea = ({
  register,
  defaultValue,
  required,
  name,
  label,
  type,
  autoComplete,
  placeholder,
  min,
  max,
  disabled,
  className,
  id
}) => {
  return (
    <>
      <Input
        {...register(`${name}`, {
          required: required === false ? false : `${label} is required!`,
          disabled: disabled === "1" ? true : false,
        })}
        defaultValue={defaultValue}
        type={type}
        placeholder={placeholder}
        name={name}
        autoComplete={autoComplete}
        min={min}
        max={max}
        id={id}
        className={className}
      />
    </>
  );
};

export default InputArea;
